import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

const edit = {
	SourceZone: null as string | null,
	SourceCity: null as string | null,
	SourceOutlet: null as string | null,
	SourceDealer: null as string | null,
	CPF: [] as number[],
	TargetZone: null as string | null,
	TargetCity: null as string | null,
	TargetOutlet: null as string | null,
	TargetDealer: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SourceDealer: [],
		CPF: [],
		TargetDealer: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
